// extracted by mini-css-extract-plugin
var _1 = "Item_menuItem__lxbIZ";
var _2 = "Item_menuItemText__qH8PH";
var _3 = "Item_menuItemTextActive__eVcyr";
var _4 = "Item_user__+EWMH";
export { _1 as "menuItem", _2 as "menuItemText", _3 as "menuItemTextActive", _4 as "user" }
